import { useState, useEffect, useRef } from 'react';
import { Form, Input, Button } from 'antd';
import cn from 'classnames';

import { AuthenticationControllerApiFactory as authAPI } from '../../api_client/parameter_api';
import { Confirm } from './Confirm';
import { LoginProps, Values } from './types';
import { handleError } from '../../utils/handleError';
import { apiLocation } from '../../config';
import './Login.less';

const Login = ({ handleConfirmLogin }: LoginProps) => {
  const [user, setUser] = useState<Record<string, string> | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const inputRef = useRef<Input | null>(null);

  useEffect(() => {
    inputRef?.current?.focus();
  }, []);

  const handleLogin = async (values: Values) => {
    const { username, password } = values;
    try {
      setLoading(true);
      await authAPI(undefined, apiLocation).userPreLogin({ username, password });
      setLoading(false);
      setUser({ username, password });
    } catch (err: any) {
      handleError(err);
      setLoading(false);
    }
  };

  return (
    <div className='login-container'>
      <div className='login-headline'>Parameter manager</div>
      {user ? (
        <Confirm confirmLogin={handleConfirmLogin} user={user} />
      ) : (
        // login form
        <div className='login-form'>
          <Form name='login-form' onFinish={handleLogin}>
            <Form.Item name='username'>
              <Input ref={inputRef} size='large' placeholder='Enter username' />
            </Form.Item>
            <Form.Item name='password'>
              <Input.Password size='large' placeholder='Enter password' />
            </Form.Item>
            <Form.Item>
              <Button size='large' type='primary' htmlType='submit' className='login-btn' loading={loading}>
                Login
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}
      <div
        className={cn({
          'login-footer': true,
          'footer-height': !!user
        })}
      ></div>
    </div>
  );
};

export default Login;
